export const API_ERROR_CODE = {
    NOT_FOUND: "-32404",
};
